export const MINIMUM_NAICS_CONFIDENCE = 0.9;
export const MINIMUM_PBA_CONFIDENCE = 0.9;
export const MINIMUM_PRODUCT_CONFIDENCE = 0.85;
export const MINIMUM_MATCH_FOUND_PERCENTAGE = 0.75;
export const MINIMUM_RECOMMENDATION_SCORE = 0.8;
export const MINIMUM_MATCH_SCORE = 0.5;